export default __webpack_public_path__ + "static/media/2.383a3efb.jpg";